module.exports = __webpack_public_path__ + "static/media/cellfinate_icono_c.e1e1e12b.svg";